import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { useKgInsight } from '@terminal/react-query-hooks/insights/useKgInsight';
import { queryKeys } from '@terminal/routes/query-params';
import { FC } from 'react';
import { CatalystWidgetView } from './CatalystWidgetView';
import { CatalystWidgetInsightContent } from './components/catalyst-widget-insight-content/CatalystWidgetInsightContent';
import { KgInsightSkeleton } from './components/kg-insight-content/KgInsightSkeleton';

interface CatalystWidgetProps {
  navigateToKGInsight: () => void;
}

export const CatalystWidget: FC<CatalystWidgetProps> = ({
  navigateToKGInsight,
}) => {
  const { params } = useQueryParams();
  const insightId = params[queryKeys.insightId] ?? '';

  const { data: kgInsight, isLoading } = useKgInsight(insightId);

  if (isLoading) {
    return <KgInsightSkeleton />;
  }

  if (!kgInsight) {
    return null;
  }

  return (
    <CatalystWidgetView subject={kgInsight.subject}>
      <CatalystWidgetInsightContent
        kgInsight={kgInsight}
        navigateToKGInsight={navigateToKGInsight}
      />
    </CatalystWidgetView>
  );
};
